if (!customElements.get('collection-subcategory-nav-slider')) {
  class CollectionSubcategoryNavSlider extends HTMLElement {
    constructor() {
      super();
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.onClickCapture = this.onClickCapture.bind(this);
    }

    connectedCallback() {
      this.slider = this.querySelector('.collection-subcategory-nav__list.slider');
      if (!this.slider) return;

      this.slider.addEventListener('pointerdown', this.onPointerDown);
      this.slider.addEventListener('dragstart', this.onDragStart);
      this.slider.addEventListener('click', this.onClickCapture, true);
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('pointerdown', this.onPointerDown);
      this.slider?.removeEventListener('dragstart', this.onDragStart);
      this.slider?.removeEventListener('click', this.onClickCapture, true);
      this.resetPointerTracking();
    }

    onDragStart(event) {
      event.preventDefault();
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse') return;
      if (event.button !== 0) return;
      if (event.target.closest('.slider-button')) return;

      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScrollLeft = this.slider.scrollLeft;
      this.isDragging = false;
      this.preventClick = false;

      this.slider.addEventListener('pointermove', this.onPointerMove);
      this.slider.addEventListener('pointerup', this.onPointerUp);
      this.slider.addEventListener('pointercancel', this.onPointerUp);
    }

    onPointerMove(event) {
      if (event.pointerId !== this.pointerId) return;

      const deltaX = event.clientX - this.startX;

      if (!this.isDragging) {
        if (Math.abs(deltaX) < 8) return;
        this.isDragging = true;
        this.slider.classList.add('is-dragging');
        if (this.slider.setPointerCapture) {
          this.slider.setPointerCapture(event.pointerId);
        }
      }

      event.preventDefault();
      this.slider.scrollLeft = this.startScrollLeft - deltaX;
    }

    onPointerUp(event) {
      if (event.pointerId !== this.pointerId) return;

      if (this.isDragging) {
        this.preventClick = true;
      }

      this.resetPointerTracking();
    }

    resetPointerTracking() {
      if (this.isDragging && this.slider?.hasPointerCapture?.(this.pointerId)) {
        this.slider.releasePointerCapture(this.pointerId);
      }

      this.isDragging = false;
      this.pointerId = null;
      this.slider?.classList.remove('is-dragging');
      this.slider?.removeEventListener('pointermove', this.onPointerMove);
      this.slider?.removeEventListener('pointerup', this.onPointerUp);
      this.slider?.removeEventListener('pointercancel', this.onPointerUp);
    }

    onClickCapture(event) {
      if (!this.preventClick) return;
      if (event.target.closest('.slider-button')) return;

      event.preventDefault();
      event.stopPropagation();
      this.preventClick = false;
    }
  }

  customElements.define('collection-subcategory-nav-slider', CollectionSubcategoryNavSlider);
}
